var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"site-container"}},[_c('headerGeneral'),_c('alerts'),_c('router-view'),_c('footerGeneral')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }